import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { Button, Input, SelectItem, Label, Collapsible } from '../../../../components/UI/ComponentsUI';
import { groupBy, isNullOrEmpty, translate } from '../../../../utils/util';
import FormPartNumberItem from './FormPartNumberItem';
import { validateInputsRequired } from '../../../../utils/handleChangeHooks';
import StockService from '../../../../services/StockService';
import SelectNew from '../../../../components/UI/SelectNew';

const FormPartNumber = (props) => {
    let firstReceipt = props.data?.receipts?.length > 0 ? props.data.receipts[0] : {}
    const [invoices, setInvoices] = useState([]);

    useEffect(() => {
        if (!isNullOrEmpty(firstReceipt?.supplier) && !props.update) {
            getSupplier(firstReceipt?.supplier);
        }

        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.data?.receipts && props.data.receipts?.length > 0) {
            let invoiceArray = []
            groupBy(props.data.receipts, 'invoice').forEach((invoice) => {
                invoiceArray.push(
                    { id: invoice.key, text: invoice.key }
                );
            })
            setInvoices([...invoiceArray]);

            if (invoiceArray.length === 1) {
                props.dataForm.invoice = invoiceArray[0].id;
            }

            if (!isNullOrEmpty(firstReceipt?.supplier) && !props.update) {
                getSupplier(firstReceipt?.supplier);
            }
        }
        // eslint-disable-next-line
    }, [props.data?.receipts]);

    const getSupplier = (sapCode) => {
        if (!isNullOrEmpty(sapCode)) {
            props.getSupplier({ sapCode: sapCode }, (response) => {
                if (response && response.name) {
                    props.onChangeSupplier(response);
                }
            })
        }
    };

    return (
        <div>
            <div className="container" style={{ marginTop: '0px', }}>
                <Collapsible
                    id="filterInvoiceMvm"
                    header={`Nota ${props.dataForm.invoice || ''}/ MVM ${props.data?.mvmNumber || ''}/ Viagem ${props.data?.journey || ''}`}
                    simple="true"
                    close={props.closeInvoices ? "true" : "false"}
                    body={
                        <div className="row">
                            <div className="input-field no-padding  col s12">
                                {invoices && invoices.length > 0 &&
                                    <SelectNew
                                        required
                                        id="invoice"
                                        name="invoice"
                                        display="text"
                                        valuefield="id"
                                        label="Notas Fiscais"
                                        placeHolder={translate('choose-one-option', 'general')}
                                        data={invoices}
                                        change={(e) => { props.onChange(e); }}
                                        value={props.dataForm?.invoice || ''}
                                    />
                                }
                            </div>
                            {props.deem &&
                                <>
                                    <div className="input-field no-padding  col s12">
                                        <Input
                                            value={props.dataForm?.cim || ''}
                                            type="text"
                                            label={translate('cim', 'physical-confirmation')}
                                            id="cim"
                                            name='cim'
                                            onChange={props.onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding  col s3">
                                        <Input
                                            required
                                            type="text"
                                            label="Placa"
                                            id="plate"
                                            name='plate'
                                            value={props.data?.plate || '-'}
                                            onChange={props.onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding  col s8">
                                        <Input
                                            value={props.dataForm?.vehicleType || ''}
                                            type="text"
                                            label="Tipo do Veiculo"
                                            id="vehicleType"
                                            name='vehicleType'
                                            onChange={props.onChange}
                                            maxLength={50}
                                        />
                                    </div>
                                </>

                            }
                            <div className="input-field no-padding  col s3">
                                <Input
                                    type="text"
                                    label="Cod. SAP"
                                    id="supplier"
                                    name='supplier'
                                    onChange={props.onChange}
                                    onBlur={(event) => getSupplier(event.currentTarget.value)}
                                    value={(props.dataForm.supplier || (firstReceipt?.supplier || ''))}
                                />
                            </div>
                            <div className="input-field no-padding  col s8">
                                <Input
                                    type="text"
                                    label="Fornecedor"
                                    id="supplierName"
                                    name='supplierName'
                                    defaultValue={firstReceipt?.supplierDescription || ''}
                                    value={props.dataForm?.supplierName || ''}
                                    onChange={props.onChange}
                                />
                            </div>
                            {
                                props.deem &&
                                <div className="input-field no-padding  col s12">
                                    <Input
                                        required
                                        type="text"
                                        label="Transportadora"
                                        id="shippingCompany"
                                        name='shippingCompany'
                                        onChange={props.onChange}
                                        value={props.dataForm?.shippingCompany || ''}
                                    />
                                </div>
                            }

                            <div className="row">
                                <Label
                                    id="data.journey"
                                    name="data.journey"
                                    class="padding col s4"
                                    label="Viagem"
                                    value={props.data?.journey || '-'} />
                                <Label
                                    id="data.mvmNumber"
                                    name="data.mvmNumber"
                                    class="padding col s3"
                                    label="Mvm"
                                    value={props.data?.mvmNumber || '-'} />
                            </div>
                        </div>
                    }
                />
            </div>
            {props.data.receipts &&
                <div className="container" >
                    <Collapsible
                        id="filterPartNumber"
                        header={`Desenho ${props.receipt?.partNumberCode || ""}`}
                        simple="true"
                        close={props.closePartnumber ? 'true' : 'false'}
                        body={
                            <>
                                <div id="formInputPartNumber" className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                                    <div className="row">
                                        <div className="input-field no-padding col s12 m4">
                                            <SelectItem
                                                required
                                                id="partNumber"
                                                name="partNumber"
                                                label="Desenho"
                                                onChange={(event) => props.onChangeSelect(event)}
                                                onChangeData={(evt) => props.onChangeSelect(evt)}
                                                defaultValue={props.filterPartNumber || ""}
                                                minLength={0}
                                                data={props.data.receipts
                                                    ? props.data.receipts?.map((i) => {
                                                        return { id: i.partNumberCode, text: i.partNumberCode };
                                                    }) : []} />
                                        </div>
                                        {props.receipt &&
                                            <>
                                                <div className="input-field no-padding col s12 m7">
                                                    <Input
                                                        disabled
                                                        value={props.receipt?.partNumberDescription || ""}
                                                        type="text"
                                                        id="receipt.partNumberDescription"
                                                        name='receipt.partNumberDescription'
                                                    />
                                                </div>
                                                <div className="input-field no-padding col s5">
                                                    <Input
                                                        disabled
                                                        value={props.receipt?.mdr || ""}
                                                        type="text"
                                                        label="MDR Origem"
                                                        id="mdr"
                                                        name='mdr'
                                                    />
                                                </div>
                                                <div className="input-field no-padding col s6">
                                                    <Input
                                                        value={props.receipt?.deem || ""}
                                                        type="text"
                                                        label={props.deem ? "Nº DEEM" : "MDR Real"}
                                                        id="deem"
                                                        name='deem'
                                                        onChange={props.onChangePartNumber}
                                                    />
                                                </div>
                                                {
                                                    !props.deem &&
                                                    <div className="input-field no-padding col s12">
                                                        <Input
                                                            value={props.receipt?.sqpNew || ""}
                                                            type="text"
                                                            label="SQP Novo"
                                                            id="sqpNew"
                                                            name='sqpNew'
                                                            onChange={props.onChangePartNumber}
                                                        />
                                                    </div>
                                                }
                                                <div className="input-field no-padding col s5">
                                                    <Input
                                                        disabled
                                                        value={parseInt((props.receipt?.accoutingQuantity || 1) / (props.receipt.qme || 1) > 0 ? 1 : 0)}
                                                        id="receipt.qmeCalc"
                                                        name='receipt.qmeCalc'
                                                        label="Volume declarado"
                                                    />
                                                </div>
                                                <div className="input-field no-padding col s6">
                                                    <Input
                                                        required
                                                        defaultValue={props.receipt?.volumeReceived || ""}
                                                        type="number"
                                                        label="Volume recebido"
                                                        id="volumeReceived"
                                                        name='volumeReceived'
                                                        onChange={props.onChangePartNumber}
                                                    />
                                                </div>
                                                <div className="input-field no-padding col s5">
                                                    <Input
                                                        disabled
                                                        value={props.receipt?.accoutingQuantity || ""}
                                                        type="text"
                                                        id="receipt.accoutingQuantity"
                                                        name='receipt.accoutingQuantity'
                                                        label="Qtd. Declarada"
                                                    />
                                                </div>
                                                <div className="input-field no-padding col s6">
                                                    <Input
                                                        required
                                                        type="number"
                                                        label="Qtd. Recebida"
                                                        id="amountReceived"
                                                        name="amountReceived"
                                                        onChange={props.onChangePartNumber}
                                                        onBlur={props.onChangePartNumber}
                                                        value={props.receipt?.amountReceived || ''}
                                                    />
                                                </div>
                                                <div className="row" style={{ paddingTop: '0px' }}>
                                                    <Button full="true" text="Adicionar" onClick={() => {
                                                        if (validateInputsRequired('formInputPartNumber')) {
                                                            props.addItem(() => { document.getElementById("partNumber").value = "" });
                                                        }
                                                    }} />
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                                {props.dataForm.items &&
                                    <FormPartNumberItem
                                        deem={props.deem}
                                        data={props.dataForm.items}
                                        removeItem={props.removedItem}
                                        onChangePartNumber={props.onChangePartNumber}
                                        editPartnumber={props.editPartnumber}
                                    />
                                }
                            </>
                        }
                    />
                </div>
            }
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSupplier: (filter, callback) => {
            dispatch(StockService.getSupplier(filter, callback));
        }
    }
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(FormPartNumber)));